import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";

class DriverBody extends Component {
  render() {
    return (
      <div>
        <div className="data-line">
          <span>Driver: </span>
          <span className="value-data">{this.props.data.DisplayName}</span>
        </div>
        <div className="data-line">
          <span>DOB: </span>
          <span className="value-data">
            {FormatUtils.formatDate(this.props.data.DateOfBirth)}
          </span>
        </div>
        <div className="data-line">
          <span>State: </span>
          <span className="value-data">{this.props.data.LicenseState}</span>
        </div>
        <div className="data-line">
          <span>License Number: </span>
          <span className="value-data">{this.props.data.LicenseNumber}</span>
        </div>
        <div className="data-line">
          <span>Active: </span>
          <span className="value-data">
            {this.props.data.Active && this.props.data.Active ? "Yes" : "No"}
          </span>
        </div>
      </div>
    );
  }
}

export default DriverBody;
